import { useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { UserContext } from "../../App";
import CheckToken from "../../_Login/CheckToken";
import toast from "react-hot-toast";
import OilSave from "../Tools/OilerOilSave";

const OilsNew = () => {

    const [user, setUser] = useContext(UserContext);
    let navigate = useNavigate();
    CheckToken(user["id"], user["token"]).then((result) => { if (!result) { setUser({}); navigate("/Login"); } });


    const handleSubmit = (e) => {

        //validate the fields
        let valid = true;

        let oilName = document.getElementById("oilName").value;

        if (oilName == "") {
            valid = false;
            toast.error("Oil Name required");
        }

        let viscosity = document.getElementById("viscosity").value;

        if (viscosity == "") {
            valid = false;
            toast.error("Viscosity required");
        }

        let description = document.getElementById("description").value;

        if (description == "") {
            valid = false;
            toast.error("Description required");
        }

        if (!valid) {
            return;
        }

        OilSave("", oilName, viscosity, description).then((response) => {

            if (!response) {
                toast.error("Save Failed.");
            }
            else {
                toast.success('Success');
                navigate("/Oils");
            }

        });
        
    };

    document.title = "Oil - New";
    return (
        <div className="oilsNew">

            {user["email"] != undefined &&
                <>
                    <div className="container body-content" style={{ marginTop: "25px" }}>

                        <h2>New Oil</h2>

                        <form noValidate="novalidate" autoComplete="off">

                            <div className="form-group">
                                <label htmlFor="oilName">Oil Name</label>
                                <input className="form-control" id="oilName" name="oilName" type="text" autoComplete="off" />
                            </div>

                            <div className="form-group">
                                <label htmlFor="viscosity">Viscosity (cSt)</label>
                                <input className="form-control" id="viscosity" name="viscosity" type="number" autoComplete="off" />
                            </div>

                            <div className="form-group">
                                <label htmlFor="description">Description</label>
                                <textarea className="form-control" id="description" name="description" autoComplete="off"></textarea>
                            </div>

                        </form>
                        <Link to="/Oils" className="btn btn-primary" style={{ marginRight: "4px" }}>Cancel</Link>
                        <button onClick={handleSubmit} className="btn btn-primary" style={{ marginRight: "4px" }}>Save</button>
                    </div>
                </>
            }
        </div>
    );
}

export default OilsNew;